import { Col, Skeleton } from "antd";

import styles from "./FormSkeleton.module.scss";

export function FormSkeleton({ fieldsCount }: { fieldsCount: number }) {
    return (
        <div className={styles.skeletonWrapper} data-testid="formSkeleton">
            {Array.from({ length: fieldsCount }).map((_, index) => (
                <div className={styles.skeletonItem} key={index}>
                    <Skeleton.Button size="small" active={true} />
                    <Col span={12}>
                        <Skeleton.Button size="large" className={styles.skeletonInput} active={true} />
                    </Col>
                </div>
            ))}
        </div>
    );
}
